import React, { Suspense, lazy, useContext } from 'react';
import Loading from './components/Loading';
import ScrollToTop from './pages/Scroll/ScrollToTop';
import AppRouter from './AppRouter';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import AmbientBackground from './components/Ambient/AmbientBackground';
import { LoadingProvider, LoadingContext } from './contexts/LoadingContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Le chatbot n'est pas nécessaire au premier rendu : chunk séparé, chargé après.
const Chatbot = lazy(() => import('./components/Chatbot/Chatbot'));

const App = ({ underSplash }) => {
  return (
    <div className={`app-container${underSplash ? ' app-container--under-splash' : ''}`}>
      <AmbientBackground />
      <ScrollToTop />
      <Header />
      <main>
        <AppRouter />
      </main>
      <Footer />
      <Suspense fallback={null}>
        <Chatbot />
      </Suspense>
    </div>
  );
};

const AppWrapper = () => {
  return (
    <ThemeProvider>
      <LoadingProvider>
        <AppWithLoading />
      </LoadingProvider>
    </ThemeProvider>
  );
};

const AppWithLoading = () => {
  const { isFirstLoad, splashFading } = useContext(LoadingContext);
  // L'app est TOUJOURS montée : elle se prépare pendant le splash (pas de
  // montage massif après coup) et le vrai DOM existe immédiatement pour les
  // audits et les robots. Le loading n'est qu'un overlay opaque par-dessus.
  // Tant que l'overlay est opaque, l'app est en opacity 0 : ce qui est caché
  // sous le splash ne doit pas être compté comme « peint » (LCP mobile mesuré
  // sur un paragraphe invisible), et l'arbre d'accessibilité reste complet.
  return (
    <>
      <App underSplash={isFirstLoad && !splashFading} />
      {isFirstLoad && <Loading />}
    </>
  );
};

export default AppWrapper;
